<div class="pager-setup" *ngIf="steps.length">
  <button
    type="button"
    class="pager-step"
    *ngFor="let step of steps; trackBy: trackByStep"
    [class.active]="step === activePage"
    [attr.aria-current]="step === activePage ? 'step' : null"
    [attr.aria-label]="'Go to setup step ' + step"
    (click)="onStepClick(step)">
    <span>
      {{ step }}
    </span>
  </button>
</div>

